import React from 'react'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import CardUI from '../../../widgets/layout/CardUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import StepProgressBarUI from '../../../widgets/output/StepProgressBarUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import ErrorMessage2UI from '../../../widgets/form/ErrorMessage2UI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import UseOfProceedsModalSF from './UseOfProceedsModalSF'
import DisbursementModalSF from './DisbursementModalSF'
import StatusUpdateModalSF from './StatusUpdateModalSF'
import LoanDetailBasicUI from './LoanDetailBasicUI'
import DailyRepaymentSF from './DailyRepaymentSF'
import LoanUpdateModalSF from './LoanUpdateModalSF'
import UpdateDepositModalSF from './UpdateDepositModalSF'
import UpdateAssignedUserModalSF from './UpdateAssignedUserModalSF'
import WaivePromoterFundModalSF from './WaivePromoterFundModalSF'
import LoanPurposeUpdateModalSF from './LoanPurposeUpdateModalSF'
import ParentLoanModalSF from './ParentLoanModalSF'
import LoanFileDownloadSF from './LoanFileDownloadSF'
import LenderUpdateModalSF from '../account/LenderUpdateModalSF'
import LoanClosedDateUpdateModalSF from './LoanClosedDateUpdateModalSF'
import LoanClosedReasonUpdateModalSF from './LoanClosedReasonUpdateModalSF'
import RequestDescUpdateModalSF from './RequestDescUpdateModalSF'
import './LoanDetail.css'

const LoanDetailUI = ({ context, loan, account, onRefreshClick,
  copyToClipboardText, onCopyToClipboard,
  onMarkSanctionSigned, enableMarkSanctionSigned, onEnableMarkSanctionSigned,
  markSanctionSignedSubmitted, markSanctionSignedErrorList,
  bankAccountList, loanList,
  // modals
  statusUpdateMode, onStatusUpdateClick, onStatusCancelClick,
  disburseMode, onDisburseClick, onDisburseCancelClick,
  amountUpdateMode, onAmountUpdateClick, onAmountUpdateCancelClick,
  onUpdateLoanClick, updateLoanMode, onCancelUpdateLoan,
  onUpdateDepositClick, updateDepositMode, onCancelUpdateDeposit,
  onAssignedUserClick, onAssignedUserCancel, assignedUserMode,
  promoterFundWaived, onWaivePromoterfundClick, onWaivePromoterfundCancelClick,
  loanPurposeUpdated, onUpdateLoanPurposeClick, onUpdateLoanPurposeCancel,
  parentLoanUpdated, onUpdateParentLoanClick, onUpdateParentLoanCancel,
  lenderUpdateMode, onLenderUpdateClick, onLenderUpdateCancelClick,
  closedDateUpdateMode, onClosedDateUpdateClick, onClosedDateUpdateCancel,
  closedReasonUpdateMode, onClosedReasonUpdateClick, onClosedReasonUpdateCancel,
  requestDescUpdateMode, onUpdateRequestDescClick, onUpdateRequestDescCancel,
  // Credit Memo props
  creditMemoList, selectedCreditMemo, generateCreditMemoRequested,
  onGenerateCreditMemo, onRefreshCreditMemos, onCreditMemoSelect, onStartChat, showChatIframe, onCloseChatIframe,
  showCreditMemoResultModal, creditMemoResultMessage, creditMemoResultType, onCloseCreditMemoResultModal,
}) =>
  <div className='su_loan'>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Loan Summary</b></span>
        </span>
      }
      right={
        <span />
      }
    />

    <div className='g_flex_h g_flex_top g_m_top_50'>
      <LeftUI context={context} loan={loan} account={account}
        copyToClipboardText={copyToClipboardText} onCopyToClipboard={onCopyToClipboard}
        onRefreshClick={onRefreshClick}
        onMarkSanctionSigned={onMarkSanctionSigned} enableMarkSanctionSigned={enableMarkSanctionSigned}
        onEnableMarkSanctionSigned={onEnableMarkSanctionSigned} markSanctionSignedSubmitted={markSanctionSignedSubmitted}
        markSanctionSignedErrorList={markSanctionSignedErrorList} bankAccountList={bankAccountList}
        onStatusUpdateClick={onStatusUpdateClick}
        amountUpdateMode={amountUpdateMode} onAmountUpdateClick={onAmountUpdateClick}
        onAmountUpdateCancelClick={onAmountUpdateCancelClick}
        onUpdateDepositClick={onUpdateDepositClick} updateDepositMode={updateDepositMode}
        onCancelUpdateDeposit={onCancelUpdateDeposit}
        onAssignedUserClick={onAssignedUserClick} onAssignedUserCancel={onAssignedUserCancel} assignedUserMode={assignedUserMode}
        promoterFundWaived={promoterFundWaived} onWaivePromoterfundClick={onWaivePromoterfundClick}
        onWaivePromoterfundCancelClick={onWaivePromoterfundCancelClick}
        onUpdateLoanPurposeClick={onUpdateLoanPurposeClick}
        parentLoanUpdated={parentLoanUpdated} onUpdateParentLoanClick={onUpdateParentLoanClick}
        lenderUpdateMode={lenderUpdateMode} onLenderUpdateClick={onLenderUpdateClick} onClosedDateUpdateClick={onClosedDateUpdateClick}
        onClosedReasonUpdateClick={onClosedReasonUpdateClick}
        onUpdateRequestDescClick={onUpdateRequestDescClick}
        creditMemoList={creditMemoList} selectedCreditMemo={selectedCreditMemo}
        generateCreditMemoRequested={generateCreditMemoRequested}
        onGenerateCreditMemo={onGenerateCreditMemo} onRefreshCreditMemos={onRefreshCreditMemos}
        onCreditMemoSelect={onCreditMemoSelect}
        onStartChat={onStartChat} showChatIframe={showChatIframe}
        onCloseChatIframe={onCloseChatIframe}
        showCreditMemoResultModal={showCreditMemoResultModal}
        creditMemoResultMessage={creditMemoResultMessage}
        creditMemoResultType={creditMemoResultType}
        onCloseCreditMemoResultModal={onCloseCreditMemoResultModal}
      />
      <RightUI context={context} loan={loan} statusUpdateMode={statusUpdateMode} onRefreshClick={onRefreshClick}
        onStatusUpdateClick={onStatusUpdateClick} onStatusCancelClick={onStatusCancelClick}
        disburseMode={disburseMode} onDisburseClick={onDisburseClick} onDisburseCancelClick={onDisburseCancelClick}
        onUpdateLoanClick={onUpdateLoanClick} updateLoanMode={updateLoanMode} onCancelUpdateLoan={onCancelUpdateLoan}
      />
    </div>

    <LoanPurposeUpdateModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
      updateMode={loanPurposeUpdated} onCancelClick={onUpdateLoanPurposeCancel} />
    <ParentLoanModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
      updateMode={parentLoanUpdated} onCancelClick={onUpdateParentLoanCancel}
      loanList={loanList} />
    <LenderUpdateModalSF context={context} loan={loan} onCancelCreate={onLenderUpdateCancelClick}
      onRefreshClick={onRefreshClick}
      lenderUpdateMode={lenderUpdateMode} />
    <LoanClosedDateUpdateModalSF context={context} loan={loan} updateMode={closedDateUpdateMode}
      onCancelClick={onClosedDateUpdateCancel} onRefreshClick={onRefreshClick} />
    <LoanClosedReasonUpdateModalSF context={context} loan={loan} updateMode={closedReasonUpdateMode}
      onCancelClick={onClosedReasonUpdateCancel} onRefreshClick={onRefreshClick} />
    <RequestDescUpdateModalSF context={context} loan={loan} updateMode={requestDescUpdateMode}
      onCancelClick={onUpdateRequestDescCancel} onRefreshClick={onRefreshClick} />
  </div>

const LeftUI = ({ context, loan, account,
  copyToClipboardText, onCopyToClipboard, onRefreshClick,
  onMarkSanctionSigned, enableMarkSanctionSigned, onEnableMarkSanctionSigned,
  markSanctionSignedSubmitted, markSanctionSignedErrorList, bankAccountList,
  amountUpdateMode, onAmountUpdateClick, onAmountUpdateCancelClick,
  onUpdateDepositClick, updateDepositMode, onCancelUpdateDeposit,
  onAssignedUserClick, onAssignedUserCancel, assignedUserMode,
  promoterFundWaived, onWaivePromoterfundClick, onWaivePromoterfundCancelClick, onUpdateLoanPurposeClick,
  onUpdateParentLoanClick, onLenderUpdateClick, onClosedDateUpdateClick, onClosedReasonUpdateClick,
  onUpdateRequestDescClick,
  creditMemoList, selectedCreditMemo, generateCreditMemoRequested,
  onGenerateCreditMemo, onRefreshCreditMemos, onCreditMemoSelect, onStartChat, showChatIframe, onCloseChatIframe,
  showCreditMemoResultModal, creditMemoResultMessage, creditMemoResultType, onCloseCreditMemoResultModal
}) =>
  <div className='g_flex_v'>
    <div className='g_m_top_50'>
      <StepProgressBarUI
        values={['requested', 'term_sheet', 'sanctioned', 'disbursed', 'closed']}
        selected={loan.status}
      />

      <div className='g_m_top_50 g_flex_h g_flex_left'>
        <BadgeUI label={loan.loanTypeLabel} />
        {
          loan.loanSubType &&
          <BadgeUI className='g_m_left_50' label={loan.loanSubType} />
        }
        {
          loan.revolveNumber != null &&
          <BadgeUI className='g_m_left_50' label={`Revolve - ${loan.revolveNumber}`} />
        }
        {/*
          <BadgeUI className='g_m_left_50' label={loan.loanRequest.purpose} />
        */}
        {
          loan.loanRequest.loanPurpose &&
          <BadgeUI className='g_m_left_50' label={loan.loanRequest.loanPurpose} />
        }
        <span className='g_m_left_50 icon icon-pencil g_link_2' onClick={onUpdateLoanPurposeClick} />
        <BadgeUI className='g_m_left_50' label={loan.appFlavor} />
        {
          loan.capex &&
          <BadgeUI className='g_m_left_50' label={'capex'} />
        }
        {
          loan.fundSource &&
          <BadgeUI className='g_m_left_50' label={loan.fundSource} />
        }
        <BadgeUI className='g_m_left_50' label={loan.assignedUserName ? loan.assignedUserName : 'Underwriter'} />
        <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onAssignedUserClick} />
        <span className='g_m_left_50 g_info2'><b>{loan.interestYearDays}</b></span>
      </div>

      <div className='g_m_top_50 g_muted'>
        Loan Id: {loan.loanId}
        <CopyToClipboard text={loan.loanId}
          onCopy={onCopyToClipboard}>
          <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
        </CopyToClipboard>
        {
          copyToClipboardText === loan.loanId &&
          <span className='g_m_left_50 g_muted'>copied</span>
        }
      </div>

      <div className='g_m_top_50 g_muted loan-request-desc-text'>
        Loan Purpose: {loan.loanRequest.requestDesc}
        <span className='g_m_left_50 icon icon-pencil g_link_2' onClick={onUpdateRequestDescClick} />
      </div>
      {/*
      <div>
        <span className='g_muted'>
          Purpose:<span className='g_m_left_50'>{loan.loanRequest.loanPurpose && loan.loanRequest.loanPurpose}</span>
        </span>
        <span className='g_m_left_50 icon icon-pencil g_link_2' onClick={onUpdateLoanPurposeClick} />
      </div>
      */}

      <div className='g_m_top_50 g_muted'>
        Parent loan: <span className='g_m_left_50'>{loan.parentLoanId ? loan.parentLoanId : 'Not set'}</span>
        <span className='g_m_left_50 icon icon-pencil g_link_2' onClick={onUpdateParentLoanClick} />
      </div>
      <div className='g_m_top_50 g_muted'>
        Loan Lender: <span className='g_m_left_50'>{loan.fundSource ? loan.fundSource : 'NA'}</span>
        <span className='g_m_left_50 icon icon-pencil g_link_2' onClick={onLenderUpdateClick} />
      </div>
      {
        loan.status === 'closed' &&
        <div className='g_m_top_50 g_muted'>
          <div>
            Closed date: <span className='g_m_left_50'>{loan.closedDateF}</span>
            {
              loan.closedDateF === null &&
              <span className='g_m_left_50 icon icon-pencil g_link_2' onClick={onClosedDateUpdateClick} />
            }
          </div>
          <div className='g_m_top_50'>
            Closed reason: <span className='g_m_left_50'>{loan.closingReason}</span>
            <span className='g_m_left_50 icon icon-pencil g_link_2' onClick={onClosedReasonUpdateClick} />
          </div>
        </div>
      }

      <div className='g_m_top_50'>
        <a href='https://docs.google.com/drawings/d/1pU3PtVl8yeeRxYV9ew7uoyxe_ru1XRc-G7Dr_jfgHYM/edit' target='_blank'>
          Loan status flow chart
        </a>
      </div>
    </div>

    {
      (loan.status === 'requested') &&
      <RequestedSectionUI loan={loan} />
    }
    {
      loan.status === 'term_sheet' &&
      <TermSheetSectionUI loan={loan} />
    }
    {
      loan.status === 'sanctioned' &&
      <SanctionedSectionUI context={context} loan={loan}
        onMarkSanctionSigned={onMarkSanctionSigned} enableMarkSanctionSigned={enableMarkSanctionSigned}
        onEnableMarkSanctionSigned={onEnableMarkSanctionSigned} markSanctionSignedSubmitted={markSanctionSignedSubmitted}
        markSanctionSignedErrorList={markSanctionSignedErrorList} bankAccountList={bankAccountList}
      />
    }

    <LoanFileDownloadSF context={context} loan={loan} account={account}
      creditMemoList={creditMemoList} selectedCreditMemo={selectedCreditMemo}
      generateCreditMemoRequested={generateCreditMemoRequested}
      onGenerateCreditMemo={onGenerateCreditMemo} onRefreshCreditMemos={onRefreshCreditMemos}
      onCreditMemoSelect={onCreditMemoSelect}
      onStartChat={onStartChat} showChatIframe={showChatIframe}
      onCloseChatIframe={onCloseChatIframe}
      showCreditMemoResultModal={showCreditMemoResultModal}
      creditMemoResultMessage={creditMemoResultMessage}
      creditMemoResultType={creditMemoResultType}
      onCloseCreditMemoResultModal={onCloseCreditMemoResultModal}
    />

    <LoanDetailBasicUI context={context} loan={loan} bankAccountList={bankAccountList}
      onAmountUpdateClick={onAmountUpdateClick} onUpdateDepositClick={onUpdateDepositClick}
      onWaivePromoterfundClick={onWaivePromoterfundClick}
    />

    <UseOfProceedsModalSF context={context} loan={loan} updateMode={amountUpdateMode}
      onCancelClick={onAmountUpdateCancelClick} onRefreshClick={onRefreshClick}
    />

    <WaivePromoterFundModalSF context={context} loan={loan} updateMode={promoterFundWaived}
      onCancelClick={onWaivePromoterfundCancelClick} onRefreshClick={onRefreshClick}
    />

    <UpdateDepositModalSF context={context} loan={loan} updateMode={updateDepositMode}
      onCancelClick={onCancelUpdateDeposit} onRefreshClick={onRefreshClick}
    />

    <UpdateAssignedUserModalSF context={context} account={loan.account} updateMode={assignedUserMode}
      onCancelClick={onAssignedUserCancel} onRefreshClick={onRefreshClick}
    />
  </div>

const RequestedSectionUI = ({ loan }) =>
  <CardUI className='g_m_top_100'>
    {(() => {
      switch (loan.subStatus) {
        case 'draft':
          return 'Borrower submitted loan request; next, borrower will pay loan application fee if applicable'
        case 'appl_fee_paid':
          return 'Borrower paid loan application fee if applicable; next, borrower will provide their GST and'
            + ' ITR data and upload bank statements'
        case 'fin_docs_collected':
          return 'Borrower\'s financial data is collected; next, borrower will provide information on projects'
            + ' to be financed if applicable'
        case 'project_added':
          return 'Borrower provided project information if applicable; next, borrower will provide reference project information'
            + ' if applicable'
        case 'references_added':
          return 'Borrower provided reference projects if applicable; next, borrower will provide use of loan proceeds if applicable'
        case 'draft_bills_added':
          return 'Borrower provided use of proceeds if applicable; next, borrower will request a term sheet'
        case 'term_sheet_requested':
          return 'Borrower requested term sheet; next, lender will offer a term sheet if applicable after due diligence'
        default:
      }
    })()}
  </CardUI>

const TermSheetSectionUI = ({ loan }) =>
  <CardUI className='g_m_top_100'>
    {(() => {
      switch (loan.subStatus) {
        case 'term_sheet_review':
          return 'Term sheet generated in Leegality; lender will review the term sheet before borrower can reivew'
        case 'term_sheet_offered':
          return 'Term sheet offered to borrower; next, borrower will pay first part of the loan processing fee if applicable'
        case 'processing_fee_1_paid':
          return 'Borrower paid first part of the loan processing fee; next, borrower will review and accept or reject the term sheet'
        case 'sanction_requested':
          return 'STP only: Waiting for score parameters; next, underwriter will enable use of proceeds and doc sigining in the app'
        default:
      }
    })()}
  </CardUI>

const SanctionedSectionUI = ({ context, loan, onMarkSanctionSigned, enableMarkSanctionSigned,
  onEnableMarkSanctionSigned, markSanctionSignedSubmitted, markSanctionSignedErrorList,
  bankAccountList
}) =>
  <CardUI className='g_m_top_100'>
    <div>
      {(() => {
        switch (loan.subStatus) {
          case 'sanction_accepted':
            return 'Borrower accepted term sheet; next, borrower will provide final use of loan proceeds if applicable'
          case 'bills_added':
            return 'Borrower provided use of proceeds if applicable; next, borrower will sign loan documents'
          case 'documents_signed':
            return 'Borrower signed loan documents; next, borrower will upload CP documents'
          case 'documents_upload':
            return 'Borrower uploading CP documents'
          case 'documents_uploaded':
            return 'Borrower uploaded CP documents; next, borrower will fund the ESCC bank account with promoter fund if applicable'
          case 'processing_fee_2_paid':
            return 'Borrower paid second part of processing fee if applicable; next, borrower will request loan disbursement'
          case 'disbursement_request':
            return 'Borrower requested loan disbursement; next, lender will disburse sancationed amount'
          default:
        }
      })()}
    </div>
    {
      (loan.subStatus === 'sanction_review' || loan.subStatus === 'sanctioned') &&
      <div className='g_m_top_50 g_flex_h g_flex_left'>
        <Link to={`/su/loans/${loan.loanId}/sanction`}>
          Update Sanction
        </Link>
      </div>
    }
    {
      loan.subStatus === 'sanctioned' &&
      <div>
        {
          markSanctionSignedErrorList &&
          <div className='g_m_top_50'>
            <ErrorMessage2UI errorList={markSanctionSignedErrorList} />
          </div>
        }
        <div className='g_m_top_50 g_flex_h g_flex_left'>
          <ButtonUI label='Mark Signed' transparent={false} onClick={onMarkSanctionSigned} disabled={!enableMarkSanctionSigned} />
          <SpinnerUI className='g_m_left_50' show={markSanctionSignedSubmitted} reserveSpace={true} />
          <input type="checkbox" className='checkbox g_m_left_50' checked={enableMarkSanctionSigned} onChange={onEnableMarkSanctionSigned} />
          <span className='g_m_left_50'>I want to mark the sanction as signed by borrower.</span>
        </div>
      </div>
    }
    {
      loan.subStatus === 'disbursement_request' &&
      <div className='g_m_top_50'>
        Transfer {loan.sanction.amountF2} from Clime Finance bank account 038605004412 to:<br /><br />
        {
          bankAccountList.filter(acc => acc.purpose === 'loan').map((bankAccount) =>
            <div>
              IFSC code: {bankAccount.ifscCode}<br />
              Bank account: {bankAccount.bankAccountNumber}<br /><br />
            </div>
          )
        }

        <DailyRepaymentSF context={context} loan={loan} />
      </div>
    }
  </CardUI>

const RightUI = ({ context, loan, statusUpdateMode, onRefreshClick, onStatusUpdateClick, onStatusCancelClick,
  disburseMode, onDisburseClick, onDisburseCancelClick,
  onUpdateLoanClick, updateLoanMode, onCancelUpdateLoan
}) =>
  <div className='g_flex_v right'>
    {
      loan.subStatus &&
      <span className='g_flex_h g_flex_right'>
        <span className='g_text_right'><BadgeUI label={loan.subStatus} /></span>
        <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onStatusUpdateClick} />
        <StatusUpdateModalSF context={context} loan={loan} updateMode={statusUpdateMode}
          onCancelClick={onStatusCancelClick} onRefreshClick={onRefreshClick}
        />
      </span>
    }
    <span className='g_flex_h g_m_top_100 g_flex_right'>
      <b className='g_text_right'>Requested</b>
      {
        loan.status === 'requested' &&
        <span className="icon icon-pencil g_m_left_50 g_cursor_pointer g_muted" onClick={onUpdateLoanClick}></span>
      }
    </span>
    <LoanUpdateModalSF context={context} onRefreshClick={onRefreshClick}
      updateMode={updateLoanMode} onCancelUpdate={onCancelUpdateLoan}
      loan={loan}
    />
    <span className='g_text_right'>{loan.loanRequest.amountF2}</span>
    <span className='g_text_right'>{loan.loanRequest.tenureMonths} months</span>
    <span className='g_text_right g_no_wrap'>{loan.loanRequest.dateF1}</span>
    {
      loan.status != 'requested' && loan.appFlavor != 'small_loan' &&
      <React.Fragment>
        <b className='g_text_right g_m_top_50'>Term sheet</b>
        <span className='g_text_right'>{loan.termSheet.amountF2}</span>
        <span className='g_text_right'>{loan.termSheet.tenureMonths} months</span>
        {
          loan.status == 'term_sheet' && loan.termSheet.interestMonths &&
          <span className='g_text_right'>Interest only: <br />{loan.termSheet.interestMonths} months</span>
        }
        <span className='g_text_right'>{loan.termSheet.interestRate}% p.a.</span>
        <span className='g_text_right g_no_wrap'>{loan.termSheet.dateF1}</span>
      </React.Fragment>
    }
    {/*
      (loan.status != 'requested' && loan.status != 'term_sheet') &&
      <React.Fragment>
        <b className='g_text_right g_m_top_50'>Sanctioned</b>
        <span className='g_text_right'>{loan.sanction.amountF2}</span>
        <span className='g_text_right'>{loan.sanction.tenureMonths} months</span>
        {
          loan.sanction.interestMonths &&
          <span className='g_text_right'>Interest only: <br />{loan.sanction.interestMonths} months</span>
        }
        <span className='g_text_right'>{loan.sanction.interestRate}% pa</span>
        <span className='g_text_right g_no_wrap'>{loan.sanction.dateF1}</span>
      </React.Fragment>
    */}
    {
      loan.status == 'disbursed' &&
      <div className='g_text_right g_m_top_50 g_flex_v'>
        <b>Disbursed</b>
        <span className='g_no_wrap'>{loan.disbursement.amountF2}</span>
        <span className='g_no_wrap'>{loan.termSheet.tenureMonths} months</span>
        {
          loan.termSheet.interestMonths &&
          <span className='g_no_wrap'>Interest only: <br />{loan.termSheet.interestMonths} months</span>
        }
        <span className='g_no_wrap'>{loan.termSheet.interestRate}% p.a.</span>
        <span className='g_no_wrap'>{loan.disbursement.dateF1}</span>
      </div>
    }
    {/*
      loan.status == 'disbursed' && loan.disbursementList.length !== 0 &&
      <div className='g_text_right g_m_top_50'>
        <b>Disbursed</b>
        {
          loan.disbursementList.map((disbursement, i) =>
            <div className='g_flex_v' key={i}>
              <span className='g_no_wrap'>{disbursement.amountF2}</span>
              <span className='g_no_wrap'>{disbursement.dateF1}</span>
            </div>
          )
        }
      </div>
      */}

    {
      context.permissions && context.permissions.includes('su_superuser_business') &&
      loan.status === 'sanctioned' && loan.subStatus === 'disbursement_request' &&
      (!loan.disbursement || !loan.disbursement.dateF1) &&
      <>
        <ButtonUI label='Disburse +' transparent={true} onClick={onDisburseClick} />
        <DisbursementModalSF context={context} loan={loan} updateMode={disburseMode}
          onCancelClick={onDisburseCancelClick} onRefreshClick={onRefreshClick} />
      </>
    }

  </div>

export default LoanDetailUI
